import BasePolicy from '@/policies/BasePolicy.js';

export default class AutomatedSurveyPolicy extends BasePolicy {
    viewAny(user) {
        return (
            user.hasPermissionTo('view all automated surveys') ||
            user.hasGroupPermissionTo('view all automated surveys')
        );
    }
}
